<template>
	<div class="ReSelectBlankServices">
		<div class="row select" >
			<div class="w-100" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать вид услуги"
					v-model="type_id"
					@change="onServiceType"
					filterable
				>
					<el-option
						v-for="(el_opt, el_index) in selServTypeOpts"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"                    
					>
					</el-option>
				</el-select>
			</div>
			<base-button type="danger" class="no-border my-0" simple icon @click="valueLocal = ''; type_id = ''; setServiceList([]);"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<div class="row select">
			<div class="w-100" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать услугу"
					v-model="valueLocal"
				>
					<el-option
						v-for="(serv, el_index) in selServOpts" 
						class="select-primary"
						:value="serv.value"
						:label="serv.label"
						:key="el_index"
					>
					</el-option>
				</el-select>
			</div>
			<base-button type="danger" class="no-border my-0" simple icon @click="valueLocal = ''; type_id=''; setServiceList([]);"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>

	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReSelectBlankServices',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props:['value'],
		data () {
			return {
				ver: 1,
				objApiData:{},
				objApiData2:{},
				objCurServ:{},
				objCurType:{},

				selServTypeOpts: [],
				selServOpts: [],  

				objGetParams: {},
				type_id: '',
				
			}
		},
		computed: {
			valueLocal:{
				get(){return this.value;},
				set(val){this.$emit('input',val);}
			}
		},
		watch:{
			
			value(val){
				// console.log('val', val)
				// this.valueLocal=val;
			},

		},
		methods: {
			/*
				Запрос для первого справочника:

				SGVO.ApiCall("GET_ROOT",{"obj":"cat_service","flt":{}})

				

				Запрос для второго справочника, если у нас есть id, отсюда можно выбрать значение parentId для первого списка

				SGVO.ApiCall("GET",{"obj":"cat_service","flt":{"id":15}})

				

				Если первый список меняем, то можно сделать запрос:

				SGVO.ApiCall("GET",{"obj":"cat_service","flt":{"parent":16}})
			
			
			*/
			setServiceList(data){
				this.selServOpts = [];
				this.objApiData2=data;
				for (let i = 0; i < data.length; i++) {
					this.selServOpts.push({'value':data[i].id.toString(),'label':data[i].name});
				}
			},
			onServiceType(type_id,bForce=false){
				if(!bForce){
					this.valueLocal = '';
				}

				if(this.objApiData && this.objApiData.length > 0 ){
					this.$GVO.ApiCall('GET',{obj:'cat_service',flt:{parent:type_id}})
					.then((objApi) => {
						if(objApi.success === true){
							//console.log(objApi);
							this.setServiceList(objApi.data);
						}
					}).catch(errorObjApi => console.error(errorObjApi));

			}
				
			},
			// onService(service_id){
			// 	for (let i = 0; i < this.objCurType.stages.length; i++) {
			// 		if(this.objCurType.stages[i].id == stage_id){
			// 			this.selServOpts = [];
			// 			this.value.service_id = '';
			// 			for (let t = 0; t < this.objCurType.stages[i].TASKS.length; t++) {
			// 				this.selServOpts.push({'value':this.objCurType.stages[i].TASKS[t].id.toString(),'label':this.objCurType.stages[i].TASKS[t].name});
			// 			}
			// 		}					
			// 	}
			// },
			// onRBChange(opt){
			// 	console.log(opt);
			// },
			getServicesList(){
				this.objGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('GET_ROOT',{obj:'cat_service',flt:{/*'cascade':true,'archived':true,'only_act':true*/}})
				.then((objApi) => {
					if(objApi.success === true){
						this.selServTypeOpts = [];
						//console.log(objApi);
						this.objApiData=objApi.data;
						for (let i = 0; i < objApi.data.length; i++) {
							this.selServTypeOpts.push({'value':objApi.data[i].id.toString(),'label':objApi.data[i].name});
						}
						// if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '' && this.multi_service === false) this.value.bp_id = this.objGetParams['bp_id'];
						// if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '' && this.multi_service === true) this.value.bp_id = this.objGetParams['bp_id'].split(',');
						// if (this.type_id != '' ) {this.onServiceType(this.type_id,true);} 

						
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			},
			findRootService(){
				// console.log('this value', this.value);
				this.$GVO.ApiCall('GET',{obj:'cat_service',flt:{id:this.valueLocal}})
				.then((objApi) => {
					if(objApi.success === true){
						this.type_id = String(objApi.parent);
						this.setServiceList(objApi.data);
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
			
		},
		mounted() {
			// console.log(this.valueLocal, this.value);
			this.getServicesList();
			if(this.valueLocal>0){
				this.findRootService();
			}
		}
	}
</script>
<style scoped>
	.row{margin-bottom: 10px;}
	.row.select{
		flex-wrap: nowrap;
		margin-right: 0;
		margin-left: 0;
	}
	.row.select>*{padding: 0px;}
</style>
